import React, { useEffect } from 'react';
import { ModalBody } from 'reactstrap';
import Rodal from '../../../components/Rodal/Rodal';
import './LoiPrepComplete.scss';

const PREPARATION_HEADER = 'LOI Preparation Complete';
const PREPARATION_TEXT =
    "The document has been prepared for signing. This tab should close automatically — if it doesn't, you can close it now and return to the dashboard.";
const EXECUTION_HEADER = 'LOI Execution Complete';
const EXECUTION_TEXT =
    'Thank you, your signature is recorded. Any co-owners will be emailed to sign, and the LOI is executed once everyone has signed.';
const CO_OWNER_HEADER = 'Signature recorded';
const CO_OWNER_TEXT =
    'Thank you, your signature on the Letter of Intent is recorded. You can close this tab. The LOI is complete once every owner has signed.';

const LoiPrepComplete = () => {
    const isSignerView = window.self !== window.top;
    const isPreparationView = !isSignerView && window.opener !== null;
    const header = isSignerView
        ? EXECUTION_HEADER
        : isPreparationView
          ? PREPARATION_HEADER
          : CO_OWNER_HEADER;
    const text = isSignerView
        ? EXECUTION_TEXT
        : isPreparationView
          ? PREPARATION_TEXT
          : CO_OWNER_TEXT;

    useEffect(() => {
        if (isPreparationView) {
            window.close();
        }
    }, [isPreparationView]);

    return (
        <Rodal
            visible={true}
            showMask={false}
            width="400"
            showCloseButton={false}
            className="loi-prep-complete">
            <ModalBody>
                <h3 className="text-center">{header}</h3>
                <span className="text-center d-block">{text}</span>
            </ModalBody>
        </Rodal>
    );
};

export default LoiPrepComplete;
